const View = require("presto-ui").baseView;
const dom = require("presto-ui").doms;

const LinearLayout = require("presto-ui").views.LinearLayout;
const ImageView = require("presto-ui").views.ImageView;
const TextView = require("presto-ui").views.TextView;
const EditText = require("presto-ui").views.EditText;

const Config = require('./../../globalConfig');
const Controller = require('./../../controller/pages/Mobile/MobilePresto');
const Strings = require('./../../res/string');
const Accessibility = require('./../../res/accessibility');
const Font = require('./../../res/fontStyle');
const Color = require('./../../res/color');
const FontSize = require('./../../res/fontSize');
const FontColor = require('./../../res/fontColor');

class MobilePresto extends Controller {

	constructor(props, children, state) {
		super(props, children, state);
		this.STR = Strings();
		this.HINT = Accessibility();
	}

	onPop = () => {}

	render = () => {
		this.layout = (
			<LinearLayout
				id={this.id("Content")}
				height="match_parent"
				width="match_parent"
				orientation="vertical"
				gravity="center_horizontal"
				background={Color.A__FFFFFFFF}
				cornerRadius="0"
				root={true}
				style={this.style_Content}>
				<LinearLayout
					id={this.id("Header")}
					height="160"
					width="match_parent"
					orientation="vertical"
					padding="40,31,40,0"
					background={Color.A__FFFFFFFF}
					cornerRadius="0"
					style={this.style_Header}>
					<ImageView
						id={this.id("Group_5")}
						height="34"
						width="match_parent"
						imageUrl="group578"
						style={this.style_Group_5} />
					<TextView
						id={this.id("Forum")}
						height="25"
						width="63"
						margin="0,44,0,0"
						text={this.STR.Forum2}
						textSize={FontSize.A_18}
						color={FontColor.A__FF3A3A3A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Forum} />
				</LinearLayout>
				<LinearLayout
					id={this.id("Body")}
					height="2600"
					width="300"
					orientation="vertical"
					margin="0,20,0,0"
					cornerRadius="0"
					style={this.style_Body}>
					<TextView
						id={this.id("Presto_")}
						height="40"
						width="match_parent"
						text={this.STR.Presto_21}
						textSize={FontSize.A_32}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_BLACK}
						lineHeight="40px"
						gravity="left"
						style={this.style_Presto_} />
					<TextView
						id={this.id("Pure_functional_appl")}
						height="120"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Pure_functional_appl48}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="40px"
						gravity="left"
						style={this.style_Pure_functional_appl} />
					<ImageView
						id={this.id("Hero_Image")}
						height="150"
						width="match_parent"
						margin="0,40,0,0"
						imageUrl="heroimage80"
						style={this.style_Hero_Image} />
					<LinearLayout
						id={this.id("Prestofloow")}
						height="203"
						width="match_parent"
						orientation="vertical"
						margin="0,80,0,0"
						style={this.style_Prestofloow}>
						<LinearLayout
							id={this.id("Line")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="4,#ff0000"
							cornerRadius="0"
							style={this.style_Line} />
						<TextView
							id={this.id("Presto_Flow")}
							height="50"
							width="match_parent"
							margin="0,30,0,0"
							text={this.STR.Presto_Flow49}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Presto_Flow} />
						<LinearLayout
							id={this.id("GroupQuickstart")}
							height="31"
							width="185"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_GroupQuickstart}>
							<ImageView
								id={this.id("Gr")}
								height="31"
								width="30"
								imageUrl="gr81"
								style={this.style_Gr} />
							<TextView
								id={this.id("Quick_St")}
								height="30"
								width="143"
								margin="12,1,0,0"
								weight="1"
								text={this.STR.Quick_Start50}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Quick_St} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Gitbub_button")}
							height="30"
							width="155"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_Gitbub_button}>
							<ImageView
								id={this.id("GitHub_Mar")}
								height="30"
								width="30"
								imageUrl="githubmar82"
								style={this.style_GitHub_Mar} />
							<TextView
								id={this.id("View_Co")}
								height="30"
								width="115"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.View_Code51}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_View_Co} />
						</LinearLayout>
					</LinearLayout>
					<TextView
						id={this.id("Code_business_flows")}
						height="120"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Code_business_flows52}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="30px"
						gravity="left"
						style={this.style_Code_business_flows} />
					<TextView
						id={this.id("Conversational_Flow")}
						height="40"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Conversational_Flow53}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Conversational_Flow} />
					<TextView
						id={this.id("Writing_code_is_like")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Writing_code_is_like54}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Writing_code_is_like} />
					<TextView
						id={this.id("Building_Blocks")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Building_Blocks55}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Building_Blocks} />
					<TextView
						id={this.id("Every_system_is_reus")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Every_system_is_reus88}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Every_system_is_reus} />
					<TextView
						id={this.id("Focus_on_Conversion")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Focus_on_Conversion57}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Focus_on_Conversion} />
					<TextView
						id={this.id("Systems_which_have_i")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Systems_which_have_i58}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Systems_which_have_i} />
					<TextView
						id={this.id("Improved_Maintainabi")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Improved_Maintainabi59}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Improved_Maintainabi} />
					<TextView
						id={this.id("Making_development_a")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Making_development_a60}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Making_development_a} />
					<LinearLayout
						id={this.id("PrestoUioo")}
						height="203"
						width="match_parent"
						orientation="vertical"
						margin="0,80,0,0"
						style={this.style_PrestoUioo}>
						<LinearLayout
							id={this.id("Line100000000ø")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="4,#ff0000"
							cornerRadius="0"
							style={this.style_Line100000000ø} />
						<TextView
							id={this.id("Presto_UI")}
							height="50"
							width="match_parent"
							margin="0,30,0,0"
							text={this.STR.Presto_UI61}
							textSize={FontSize.A_40}
							color={FontColor.A__FF000000}
							fontStyle={Font.AVENIR_BLACK}
							lineHeight="42px"
							gravity="left"
							style={this.style_Presto_UI} />
						<LinearLayout
							id={this.id("Group7Quickstart")}
							height="31"
							width="185"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_Group7Quickstart}>
							<ImageView
								id={this.id("Group_7")}
								height="31"
								width="30"
								imageUrl="group783"
								style={this.style_Group_7} />
							<TextView
								id={this.id("Quick_Start")}
								height="30"
								width="143"
								margin="12,1,0,0"
								weight="1"
								text={this.STR.Quick_Start50}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_Quick_Start} />
						</LinearLayout>
						<LinearLayout
							id={this.id("ViewcodeGithubmark")}
							height="30"
							width="155"
							orientation="horizontal"
							margin="0,30,0,0"
							style={this.style_ViewcodeGithubmark}>
							<ImageView
								id={this.id("GitHub_Mark")}
								height="30"
								width="30"
								imageUrl="githubmark84"
								style={this.style_GitHub_Mark} />
							<TextView
								id={this.id("View_Code")}
								height="30"
								width="115"
								margin="10,0,0,0"
								weight="1"
								text={this.STR.View_Code51}
								textSize={FontSize.A_22}
								color={FontColor.A__FFFF0000}
								fontStyle={Font.AVENIR_HEAVY}
								gravity="left"
								style={this.style_View_Code} />
						</LinearLayout>
					</LinearLayout>
					<TextView
						id={this.id("Generate_UI_Code_dir")}
						height="120"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Generate_UI_Code_dir89}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="30px"
						gravity="left"
						style={this.style_Generate_UI_Code_dir} />
					<TextView
						id={this.id("Single_Source_Code")}
						height="40"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Single_Source_Code63}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Single_Source_Code} />
					<TextView
						id={this.id("Design_once_and_have")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Design_once_and_have64}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Design_once_and_have} />
					<TextView
						id={this.id("Full_Control")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Full_Control65}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Full_Control} />
					<TextView
						id={this.id("Change_the_UI_withou")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Change_the_UI_withou66}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Change_the_UI_withou} />
					<TextView
						id={this.id("Syntax")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Syntax67}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Syntax} />
					<TextView
						id={this.id("Inspired_by_Android")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Inspired_by_Android68}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Inspired_by_Android} />
					<TextView
						id={this.id("Quick_Development")}
						height="40"
						width="match_parent"
						margin="0,20,0,0"
						text={this.STR.Quick_Development69}
						textSize={FontSize.A_26}
						color={FontColor.A__FF000000}
						fontStyle={Font.AVENIR_MEDIUM}
						lineHeight="42px"
						gravity="left"
						style={this.style_Quick_Development} />
					<TextView
						id={this.id("Auto_generate_UI_cod")}
						height="60"
						width="match_parent"
						margin="0,10,0,0"
						text={this.STR.Auto_generate_UI_cod70}
						textSize={FontSize.A_20}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						lineHeight="28px"
						gravity="left"
						style={this.style_Auto_generate_UI_cod} />
					<LinearLayout
						id={this.id("Line_4")}
						height="2"
						width="match_parent"
						background={Color.A__FFD7D7D7}
						stroke="4,#ff0000"
						margin="0,50,0,0"
						cornerRadius="0"
						style={this.style_Line_4} />
					<TextView
						id={this.id("Get_the_latest_Prest")}
						height="60"
						width="match_parent"
						margin="0,30,0,0"
						text={this.STR.Get_the_latest_Prest71}
						textSize={FontSize.A_18}
						color={FontColor.A__FF4A494A}
						fontStyle={Font.AVENIR_ROMAN}
						gravity="left"
						style={this.style_Get_the_latest_Prest} />
					<LinearLayout
						id={this.id("Group")}
						height="36"
						width="match_parent"
						orientation="vertical"
						gravity="center_horizontal"
						margin="0,20,0,0"
						style={this.style_Group}>
						<LinearLayout
							id={this.id("YouremailaddressNoun_1358889_cc")}
							height="25"
							width="match_parent"
							orientation="horizontal"
							style={this.style_YouremailaddressNoun_1358889_cc}>
							<ImageView
								id={this.id("Noun_1358889_cc")}
								height="20"
								width="34"
								margin="0,4,0,0"
								imageUrl="noun_1358889_cc85"
								style={this.style_Noun_1358889_cc} />
							<EditText
								id={this.id("Your_email_address")}
								height="25"
								width="248"
								margin="18,0,0,0"
								weight="1"
								textSize={FontSize.A_18}
								color={FontColor.A__FFCCCCCC}
								fontStyle={Font.AVENIR_ROMAN}
								gravity="left"
								hint={this.STR.Your_email_address72}
								background="#ffffff"
								padding="0,0,0,0"
								style={this.style_Your_email_address} />
						</LinearLayout>
						<LinearLayout
							id={this.id("Line_3")}
							height="2"
							width="match_parent"
							background={Color.A__FFD7D7D7}
							stroke="1,#ff0000"
							margin="0,9,0,0"
							cornerRadius="0"
							style={this.style_Line_3} />
					</LinearLayout>
					<TextView
						id={this.id("Subscribe")}
						height="30"
						width="101"
						margin="0,20,0,0"
						text={this.STR.Subscribe73}
						textSize={FontSize.A_22}
						color={FontColor.A__FFFF0000}
						fontStyle={Font.AVENIR_HEAVY}
						gravity="left"
						style={this.style_Subscribe} />
					<LinearLayout
						id={this.id("Rectangle_2")}
						height="39"
						width="match_parent"
						background={Color.A__FFFFFFFF}
						margin="0,7,0,0"
						cornerRadius="0"
						style={this.style_Rectangle_2} />
				</LinearLayout>
			</LinearLayout>
		);
		this.containerId = this.layout.idSet.id;
		return this.layout.render();
	}

};

module.exports = MobilePresto;



// WEBPACK FOOTER //
// ./views/Mobile/MobilePresto.js